/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentProtocolEnum } from './ConversationalAgentProtocolEnum';
import {
  ConversationalAgentProtocolEnumFromJSON,
  ConversationalAgentProtocolEnumFromJSONTyped,
  ConversationalAgentProtocolEnumToJSON,
} from './ConversationalAgentProtocolEnum';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';

/**
 *
 * @export
 * @interface ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant
 */
export interface ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant {
  /**
   *
   * @type {ConversationalAgentProtocolEnum}
   * @memberof ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant
   */
  protocol: ConversationalAgentProtocolEnum;
  /**
   *
   * @type {number}
   * @memberof ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant
   */
  name?: string | null;
  /**
   *
   * @type {CredentialRead}
   * @memberof ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant
   */
  assistantId: string;
}

/**
 * Check if a given object implements the ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant interface.
 */
export function instanceOfConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant(
  value: object,
): value is ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('assistantId' in value) || value['assistantId'] === undefined) return false;
  return true;
}

export function ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistantFromJSON(
  json: any,
): ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant {
  return ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistantFromJSONTyped(json, false);
}

export function ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistantFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant {
  if (json == null) {
    return json;
  }
  return {
    protocol: ConversationalAgentProtocolEnumFromJSON(json['protocol']),
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    assistantId: json['assistant_id'],
  };
}

export function ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistantToJSON(
  value?: Omit<
    ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant,
    'id' | 'credential'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: ConversationalAgentProtocolEnumToJSON(value['protocol']),
    name: value['name'],
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    assistant_id: value['assistantId'],
  };
}
